__turbopack_context__.v({
  "productReviewsHeader": "ProductReviews-module-scss-module__-zNLVq__productReviewsHeader",
  "productReviewsSection": "ProductReviews-module-scss-module__-zNLVq__productReviewsSection",
  "productReviewsSubtitle": "ProductReviews-module-scss-module__-zNLVq__productReviewsSubtitle",
  "productReviewsTitle": "ProductReviews-module-scss-module__-zNLVq__productReviewsTitle",
});
